import React, { useEffect } from "react";
import { Card, ReactDataTableComponentProps } from "@bb-vendure/admin-ui/react";
import { useState } from "react";
import useGetCustomsClearance from "./graphql/Get-Customs-Clearance";
import { colorByState } from "./helper";

export default function CustomsClearanceState({
  rowItem,
}: ReactDataTableComponentProps<{ id: string }>) {
  const [customsClearanceState, setCustomsClearanceState] = useState("");
  const { data, loading, error } = useGetCustomsClearance(rowItem.id, false);

  useEffect(() => {
    if (data && !customsClearanceState) {
      setCustomsClearanceState(
        (data as any).customsClearance && (data as any).customsClearance.state
          ? (data as any).customsClearance.state
          : "No customs clearance provided"
      );
    }
  }, [data]);

  return (
    <div
      className={`button ${colorByState(customsClearanceState)}`}
      style={{
        marginLeft: "8px",
        borderRadius: "24px",
        cursor: "default",
        padding: "2px 8px 2px 8px",
        fontSize: "12px",
      }}
    >
      {customsClearanceState}
    </div>
  );
}
